export default __webpack_public_path__ + "static/media/coiffeur-res-btn.e6bdc4de.svg";